
// Import module styles.
import "./layout.view.less";

// Define controllers.
window.e0pw7v = {
	NavController
};

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function NavController() {

	return {
		// Public properties.
		isOpen: false,

		// Public methods.
		toggleMenu: toggleMenu,
	};

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I manage the opening / closing of the menu on narrow devices.
	*/
	function toggleMenu() {

		this.isOpen = ! this.isOpen;

	}

}
